import { useEffect, useMemo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import ChatWidget from '../components/ChatWidget'
import SeoHead from '../components/SeoHead'
import { pageSeo, organizationLd, SITE_URL } from '../seo'

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.groupeouambo.com'

function PublicLayout({ t, lang, setLang, year }) {
  const location = useLocation()
  const seo = useMemo(() => pageSeo(lang, location.pathname), [lang, location.pathname])
  const path = seo.path || '/'
  const alternates = useMemo(() => ([
    { hreflang: 'en', href: `${SITE_URL}${path}${path.includes('?') ? '&' : '?'}lang=en` },
    { hreflang: 'fr', href: `${SITE_URL}${path}${path.includes('?') ? '&' : '?'}lang=fr` },
    { hreflang: 'x-default', href: `${SITE_URL}${path}` },
  ]), [path])

  useEffect(() => {
    fetch(`${API_URL}/visitors/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: location.pathname,
        referrer: document.referrer || null,
        device: navigator.userAgent.slice(0, 300),
      }),
    }).catch(() => {})
  }, [location.pathname])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <SeoHead
        title={seo.title}
        description={seo.description}
        path={seo.path}
        lang={lang}
        jsonLd={location.pathname === '/' ? organizationLd : null}
        alternates={alternates}
      />

      <Header t={t} lang={lang} setLang={setLang} />

      <main className="site-main">
        <Outlet />
      </main>

      <Footer t={t} year={year} lang={lang} />

      <ChatWidget />
    </div>
  )
}

export default PublicLayout
